import { useEffect } from "react";
import { IDynamicFieldProps } from "../DynamicFormContracts";
import useDynamicFormState from "./useDynamicFormState";

export interface IuseDynamicFieldValidatorProps<V, A> {
  validators: ((value: V, attributes: A) => boolean)[];
  props: IDynamicFieldProps;
}

export default function useDynamicFieldValidator<V, A>({
  validators,
  props,
}: IuseDynamicFieldValidatorProps<V, A>) {
  const prevError = (useDynamicFormState<V>().error as any)[props.name] as boolean;
  useEffect(() => {
    let newError = false;
    for (let validator of validators) {
      newError = !validator(props.value, props.attributes);
      if (newError) break;
    }
    if (props.onError && prevError !== newError) {
      props.onError({ type: "error", target: { name: props.name, value: newError } });
    }
  }, [props.value]);
}
